module.exports = __webpack_public_path__ + "static/media/thunder.7e168c53.svg";